// client/src/pages/common/PrivacyPolicy.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';

const PrivacyPolicy = () => {
  const { t } = useTranslation('legal');

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-lg shadow-md p-6 sm:p-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('privacy.title')}</h1>
          <p className="text-sm text-gray-500 mb-8">{t('privacy.lastUpdated')}</p>

          <p className="text-gray-700 mb-8">{t('privacy.intro')}</p>

          {/* Section 1 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">1. {t('privacy.dataCollected.title')}</h2>
          <p className="text-gray-700 mb-2">{t('privacy.dataCollected.intro')}</p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
            <li><strong>{t('privacy.dataCollected.corporate')}:</strong> {t('privacy.dataCollected.corporateDesc')}</li>
            <li><strong>{t('privacy.dataCollected.contact')}:</strong> {t('privacy.dataCollected.contactDesc')}</li>
            <li><strong>{t('privacy.dataCollected.transactions')}:</strong> {t('privacy.dataCollected.transactionsDesc')}</li>
            <li><strong>{t('privacy.dataCollected.technical')}:</strong> {t('privacy.dataCollected.technicalDesc')}</li>
          </ul>

          {/* Section 2 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">2. {t('privacy.purpose.title')}</h2>
          <p className="text-gray-700 mb-2">{t('privacy.purpose.intro')}</p>
          <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
            <li>{t('privacy.purpose.accountManagement')}</li>
            <li>{t('privacy.purpose.orderForwarding')}</li>
            <li>{t('privacy.purpose.technicalSupport')}</li>
            <li>{t('privacy.purpose.systemNotifications')}</li>
          </ul>
          <p className="text-gray-700 mb-6">{t('privacy.purpose.legalBasis')}</p>

          {/* Section 3 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">3. {t('privacy.sharing.title')}</h2>
          <p className="text-gray-700 mb-2">{t('privacy.sharing.intro')}</p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
            <li>{t('privacy.sharing.wholesaler')}</li>
            <li>{t('privacy.sharing.providers')}</li>
          </ul>

          {/* Section 4 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">4. {t('privacy.role.title')}</h2>
          <p className="text-gray-700 mb-6">{t('privacy.role.body')}</p>

          {/* Section 5 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">5. {t('privacy.retention.title')}</h2>
          <p className="text-gray-700 mb-6">{t('privacy.retention.body')}</p>

          {/* Section 6 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">6. {t('privacy.rights.title')}</h2>
          <p className="text-gray-700 mb-2">{t('privacy.rights.intro')}</p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
            <li>{t('privacy.rights.access')}</li>
            <li>{t('privacy.rights.rectification')}</li>
            <li>{t('privacy.rights.erasure')}</li>
            <li>{t('privacy.rights.restriction')}</li>
          </ul>

          {/* Section 7 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">7. {t('privacy.cookies.title')}</h2>
          <p className="text-gray-700 mb-6">{t('privacy.cookies.body')}</p>

          {/* Section 8 */}
          <h2 className="text-xl font-bold text-gray-800 mb-3">8. {t('privacy.contactSection.title')}</h2>
          <p className="text-gray-700 mb-4">{t('privacy.contactSection.body')}: <a href="mailto:charitakistheodoros@gmail.com" className="text-blue-600 hover:underline">charitakistheodoros@gmail.com</a></p>

          <div className="mt-6">
            <Link to="/terms" className="text-blue-600 hover:underline text-sm">{t('terms.title')} &rarr;</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
